import type { GpProduct } from '@/app/editor/iframe/atom/module/GpProduct';
import { HookAtomRender } from '@/app/editor/iframe/atom/atom-service/render/BaseAtomRender';
import HELPER from '@/app/utils/HELPER';
import api from '@/app/endpoints.js';
import getFieldSettings from '@/app/utils/getFieldSettings';
import { GET } from '@/app/api/index';
import STORE from '@/app/store/store';
// import { QueueAtomRender } from "./QueueAtomRender";
declare let Liquid: any;

type ProductShopify = {
  id: string;
  real_id: string;
  title: string;
  handle: string;
  variants: Array<VariantShopify>;
  images: Array<ImageShopify>;
  image: ImageShopify;
  selected_or_first_available_variant: VariantShopify;
  selected: VariantShopify;
};

type VariantShopify = {
  id: number;
  inventory_quantity: string;
  inventory_management: string;
  available: boolean;
  image: string;
  featured_image: string;
};

type ImageShopify = {
  id: number;
  variant_ids: string;
  src: string;
};

/**
 * ProductAtomRender
 */
class ProductAtomRender extends HookAtomRender {
  public atom: GpProduct;

  /**
   * class ProductAtomRender extends BaseAtomRender {
   * @param atom GpProduct
   */
  constructor(atom: GpProduct) {
    super(atom);
  }

  /**
   * override renderLiquid từ Atom
   * @param templateTmp template string
   * @returns html string
   */
  async renderLiquid(templateTmp: string): Promise<string> {
    let template = HELPER.simpleHTMLEntities(templateTmp);
    const product = await this.getProductInShopify();

    const atomModel = this.getAtomModel();
    template = HELPER.replaceFields(atomModel.settings, template);

    // check if not latest product option
    if (product.id != 'auto') {
      // Nếu API trả về giá trị khác auto thì cần tự động cập nhật trong settings theo dữ liêu của API Trả về
      const productTitle = product.title;
      const productId = product.id;
      const productHandle = product.handle;
      const mapFields = getFieldSettings(this.getAtomModel().settings);
      if (Object(mapFields)['product']) {
        const field = Object(mapFields)['product'];
        field['default_value'] = productTitle;
      }
      if (Object(mapFields)['pid']) {
        const field = Object(mapFields)['pid'];
        field['default_value'] = productId;
      }
      if (Object(mapFields)['pHandle']) {
        const field = Object(mapFields)['pHandle'];
        field['default_value'] = productHandle;
      }
      this.atom.setSettings(this.getAtomModel().settings);
    }

    // Cập nhật product vào cache
    const productData = JSON.parse(JSON.stringify(product));
    HELPER.updateProductInList(productData);

    // Render liquid
    const tmpl = Liquid.parse(template);
    let html: string = tmpl.render({
      ...this.getAtomModel().data,
      product: product,
    });

    // Format html with product new
    html = this.formatHtmlWithProduct(product, html);

    return html;
  }

  /**..
   * Tạo vỏ Product
   * @param data ProductShopify
   * @param html string
   * @returns template HtmlWithProduct
   */
  formatHtmlWithProduct(data: ProductShopify, html: string): string {
    const $hmtl = jQuery('<div>' + html + '</div>');
    const productId = data.id;
    const productHandle = data.handle;

    let index = 0;
    const dataIndex = $hmtl.attr('data-index');
    if (dataIndex != undefined) {
      index = parseInt(dataIndex) - 1;
    }
    $hmtl
      .find('.module')
      .attr('data-pid', productId)
      .attr('data-pHandle', productHandle)
      .attr('data-index', index + 1);

    return $hmtl.html();
  }

  /**
   * format ProductData
   * @param data ProductShopify
   * @returns data with specials key
   */
  formatProductData(data: ProductShopify): ProductShopify {
    // selected_or_first_available_variant cho liquid
    let selectedVariant = {} as VariantShopify;
    let selectedVariantIndex = 0;
    let featuredImage = '';

    // set available
    for (let i = 0; i < data['variants'].length; i++) {
      const variant = data['variants'][i];

      const inventory = parseInt(variant['inventory_quantity']);
      const inventoryManagement = variant['inventory_management'];

      if (inventory > 0 || inventoryManagement != 'shopify') {
        variant.available = true;
      } else {
        variant.available = false;
      }
    }
    // selected variant
    const variantId = this.get$el().children('.module').attr('data-variant');
    if (variantId != undefined && variantId != 'auto') {
      for (let i = 0; i < data['variants'].length; i++) {
        if (variantId.toString() == data['variants'][i].id.toString()) {
          selectedVariantIndex = i;
          break;
        }
      }
    } else {
      // or first available
      for (let i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          selectedVariantIndex = i;
          break;
        }
      }
    }

    if (data['variants'] != undefined && data['variants'].length > 1) {
      selectedVariant = data['variants'][selectedVariantIndex];

      // eslint-disable-next-line @typescript-eslint/camelcase
      outerLoop: for (let i = 0; i < data['images'].length; i++) {
        const selectedVariantImage = data['images'][i];

        const variantIds = selectedVariantImage.variant_ids;
        for (let j = 0; j < variantIds.length; j++) {
          if (selectedVariant.id.toString() == variantIds[j].toString()) {
            selectedVariant.image = selectedVariantImage.src;
            featuredImage = selectedVariantImage.src;
            // eslint-disable-next-line @typescript-eslint/camelcase
            break outerLoop;
          }
        }
      }
      // set featured_image
      if (variantId != undefined && variantId != 'auto') {
        if (featuredImage != '') {
          selectedVariant['featured_image'] = featuredImage;
        } else if (data.image != undefined && data.image.src != '') {
          selectedVariant['featured_image'] = data.image.src;
        }
      } else {
        if (data.image != undefined && data.image.src != '') {
          selectedVariant['featured_image'] = data.image.src;
        } else {
          selectedVariant['featured_image'] = '';
        }
      }
      data['selected_or_first_available_variant'] = selectedVariant;
      data.selected = selectedVariant;
    } else if (data['variants'] != undefined && data['variants'].length == 1) {
      data['selected_or_first_available_variant'] = data['variants'][0];
      data.selected = data['variants'][0];

      if (data['image'] != undefined) {
        data.selected_or_first_available_variant['featured_image'] = data['image'].src;
        data.selected['featured_image'] = data['image'].src;
      } else {
        data.selected_or_first_available_variant['featured_image'] = '';
      }
    }

    return data;
  }

  /**
   * Call ajax to get product form backend
   * @returns data Promise with type ProductShopify
   */
  async getProductInShopify(): Promise<ProductShopify> {
    let productData = {} as ProductShopify;
    let productId: string | undefined = this.get$el().children('.module').attr('data-pid');
    if (!productId) {
      productId = 'auto';
    }

    productData = HELPER.searchProductInList(productId) as ProductShopify;
    if (!jQuery.isEmptyObject(productData)) {
      // Nếu có product trong cache window
      return this.formatProductData(productData);
    }

    // load ajax
    const shop = STORE.getValue('__shop').shopifyDomain;

    // TODO: Fix tạm thời
    /**
     * implement call Ajax
     * override Promise funcion: resolve(), reject()
     * @returns data Promise
     */
    const getProduct = () => {
      return new Promise(async (resolve, reject) => {
        const data = {
          shop: shop,
          productId: productId,
        };
        try {
          const res = await GET(api.getProduct().url, data);
          let jsonData = {
            product: {},
          };
          let productData;
          if (res != undefined && res.products && res.products.length) {
            productData = res.products[0];
            jsonData = {
              product: productData,
            };
          }
          if (productData != undefined && productData.id != undefined) {
            if (productId == 'auto') {
              productData['real_id'] = productData.id;
              productData.id = 'auto';
            }
            HELPER.updateProductInList(productData);
          }

          // Callbacks
          resolve(jsonData);
        } catch (err) {
          if (productId != 'auto') {
            this.get$el().children('.module').attr('data-pid', 'auto').attr('data-phandle', 'auto');
            const moduleId = this.atom.getId();
            const $bkActiveModule = this.get$divContentBk().find('#module-' + moduleId);
            const $settings = $bkActiveModule.find('.settings');
            let fields = [];
            try {
              fields = JSON.parse($settings.html());
            } catch (err) {
              // eslint-disable-next-line no-console
              console.log(err.message);
            }
            for (let i = 0; i < fields.length; i++) {
              if (fields[i].name == 'product') {
                fields[i]['default_value'] = 'Auto';
              }
              if (fields[i].name == 'pid') {
                fields[i]['default_value'] = 'auto';
              }
              if (fields[i].name == 'pHandle') {
                fields[i]['default_value'] = 'auto';
              }
            }

            $settings.html(JSON.stringify(fields));
            reject();
          } else {
            // callback(jsonData, productId);
            HELPER.showNotify('There are some errors occurred please try again. Error: 100', 'error', undefined);
            resolve({
              products: [],
            });
          }
        }
      });
    };
    let err = false;
    await getProduct().catch(() => {
      err = true;
    });
    if (err) {
      return this.getProductInShopify();
    }

    return this.formatProductData(productData);
  }
}

export default ProductAtomRender;
